import { render } from "./tab-header.vue?vue&type=template&id=da3c5430&lang=pug"
import script from "./tab-header.vue?vue&type=script&lang=js"
export * from "./tab-header.vue?vue&type=script&lang=js"
script.render = render

export default script